function AppointmentBlockLabel({ block }) {
  // TODO: localized auto-format based on start and end dates
  return block.label;
}

export default AppointmentBlockLabel;
